export const actionTakenOptions = [
  'Case created for FST revisit',
  'Corrected in Genisis',
  'Sent to FS Supervisor/Manager',
  `Can't OTA`,
];

export const incorrectStatusOptions = [
  'Case created incorrect / Serial number not captured',
  'Case was not completed and Serial number not recorded',
  'Hostname and site name incorrect',
  'Hostname correction',
  'OTA complete but requires FST visit',
  'OTA incomplete',
  'Pending OTA',
  'Removal',
  'Ventus not in Genesis',
  '2-Port Ventus (maybe MI specific)',
  'Ventus not in Cadence',
];
